<template functional>
  <div class="row">
    <div class="col-md-6 col-sm-12 color-black font-16 font-weight-bold">
      {{ props.peiTransportationName }}
    </div>
    <div class="col-md-6 col-sm-12 d-flex">
      <span class="font-14 color-secondary-6 font-weight-normal">
        Acompañante:
      </span>
      <div class="color-black font-14 font-weight-bold ml-2">
        {{ props.companionFlag === '1' ? 'Si' : 'No' }}
      </div>
    </div>
    <div class="col-md-6 col-sm-12 d-flex">
      <span class="font-14 color-secondary-6 font-weight-normal">
        Millaje:
      </span>
      <div class="color-primary-2 font-14 font-weight-bold ml-2">
        {{ props.mileage || '-' }}
      </div>
    </div>
    <div class="col-md-6 col-sm-12 d-flex">
      <span class="font-14 color-secondary-6 font-weight-normal">
        Total:
      </span>
      <div
        v-if="props.peiTransportationName == 'BECA'"
        class="color-primary-1 font-14 font-weight-bold ml-2"
      >
        {{ props.serviceDailyCost | price }}
      </div>
      <p v-else>
        -
      </p>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    evalAvailableColor() {
      return (price) =>
        price
          ? Math.sign(price) > 0
            ? 'font-weight-bold color-secondary-22'
            : 'font-weight-bold color-secondary-20'
          : 'font-weight-bold color-black';
    },
  },
  methods: {},
};
</script>
